import api from "../index";

export const GetPlanListApi = () => api.post("plan-list");
export const AddLicenseApi = (data, header) => api.post("addlicense", data, header);
export const EditLicenseApi = (data, header) => api.post("edit-license", data, header);
export const deleteLicenseApi = (data) => api.post("delete-license", data);
export const deleteLicenseAdminPermanentlyApi = (data) =>
  api.post("delete-license-admin-permanently", data);
export const AdminWiseClients = (data) => api.post("admin-wise-client-list",data);
export const GetEmployeeList = (data) => api.post("getemployeelist",data);
export const UpgradeLicensePlanApi = (data) => api.post("initiate-license-payment",data);
export const GetLicenseHistoryApi = (data) => api.post("get-license-history", data);
export const GetPaymentTypesApi = (data) => api.post("get-payment-types", data);
